<section class="content-layout content-layout-3">
  <div class="container">
    <div class="row">
      @if (breakpoint() === "mobile") {
        <ng-container class="row">
          <div class="col-xs-12">
            @if (title()) {
              <app-title [titles]="[title()]" class="title" />
            }
          </div>
          <div class="col-xs-12">
            @if (data().html; as html) {
              <div [innerHTML]="html" class="paragraph"></div>
            }
          </div>
          @if (data().image; as image) {
            <div class="col-xs-12">
              <figure class="figure">
                <app-image [image]="image" [size]="{ dw: 400, dh: 480, mh: 409 }" class="img" />
                @if (data().legend; as legend) {
                  <figcaption>
                    <hr class="separator" />
                    <p [innerHTML]="legend" class="legend"></p>
                  </figcaption>
                }
              </figure>
            </div>
          }
          <div class="items col-xs-12">
            @if (surfaceTitle(); as surfaceTitle) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[surfaceTitle]" />
                <p>Surface au sol</p>
              </div>
            }
            @if (locationTitle(); as locationTitle) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[locationTitle]" />
                <p>Localisation du bien</p>
              </div>
            }
            @if (budgetTitle(); as budgetTitle) {
              <div class="item">
                <hr class="separator" />
                <div class="budget-content">
                  <app-title [titles]="[budgetTitle]" />
                  @if (data().financingPopupContent) {
                    <i (click)="openFinancingPopup()" [iconName]="'INFO_CIRCLE'" color="WHITE" size="20"></i>
                  }
                </div>
                <p>Enveloppe budgétaire</p>
              </div>
            }
            @if (designerTitle(); as designerTitle) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[designerTitle]" />
                <p>Agenceur Perene</p>
              </div>
            }
            @if (collaborationTitle(); as collaborationTitle) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[collaborationTitle]" />
                <p>Collaboration</p>
              </div>
            }
          </div>
        </ng-container>
      } @else {
        <div class="col-lg-4">
          <figure class="figure">
            @if (data().image; as image) {
              <app-image [image]="image" [size]="{ dw: 400, dh: 480, mh: 409 }" class="img" />
            }
            @if (data().legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <p [innerHTML]="legend" class="legend"></p>
              </figcaption>
            }
          </figure>
        </div>
        <div class="col-lg-6 col-lg-offset-2">
          @if (title()) {
            <app-title [titles]="[title()]" class="title" />
          }
          @if (data().html; as html) {
            <div [innerHTML]="html" class="paragraph"></div>
          }
          <div class="items">
            @if (surfaceTitle()) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[surfaceTitle()]" />
                <p>Surface au sol</p>
              </div>
            }
            @if (locationTitle()) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[locationTitle()]" />
                <p>Localisation du bien</p>
              </div>
            }
            @if (budgetTitle()) {
              <div class="item">
                <hr class="separator" />
                <div class="budget-content">
                  <app-title [titles]="[budgetTitle()]" />
                  @if (data().financingPopupContent) {
                    <i (click)="openFinancingPopup()" [iconName]="'INFO_CIRCLE'" color="WHITE" size="24"></i>
                  }
                </div>
                <p>Enveloppe budgétaire</p>
              </div>
            }
            @if (designerTitle()) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[designerTitle()]" />
                <p>Agenceur Perene</p>
              </div>
            }
            @if (collaborationTitle()) {
              <div class="item">
                <hr class="separator" />
                <app-title [titles]="[collaborationTitle()]" />
                <p>Collaboration</p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
<dialog [open]="financingDialogOpen()" class="financing-dialog">
  @let isMobile = this.breakpoint() === "mobile";
  @let popin = formattedPopin();
  @if (popin) {
    <div (clickOutside)="closePopin()" class="popin">
      <div (click)="closePopin()" class="btn-close">
        <i [iconName]="'CLOSE_THIN'" [size]="isMobile ? '2rem' : '3rem'" color="GREY_LIGHT"></i>
      </div>
      <div class="title">
        {{ popin.title }}
      </div>
      <div class="subtitle">Détail de l'offre de financement</div>
      <div class="flex-col-between little-size">
        <div>Type de financement</div>
        <div>Vente à crédit</div>
      </div>
      <div class="flex-col-between little-size">
        <div>Montant de l'apport (30%)</div>
        <div>{{ popin.downPaymentAmount | currency: "EUR" }}</div>
      </div>
      <div class="flex-col-between little-size">
        <div>Montant du crédit</div>
        <div>{{ popin.creditAmount | currency: "EUR" }}</div>
      </div>
      <div class="subtitle">Simulation de financement</div>
      <div class="text-right little-size">Hors assurance facultative</div>
      <div class="flex-col-between">
        <div>
          <span class="little-size">{{ popin.installmentsCount }}</span
          ><span class="big-size"> mensualités de :</span>
        </div>
        <div class="big-size">{{ popin.monthlyInstallmentAmount | currency: "EUR" }}</div>
      </div>
      <div class="flex-col-between big-size">
        <div>Montant Total dû :</div>
        <div>{{ popin.totalAmountDue | currency: "EUR" }}</div>
      </div>
      <div class="flex-col-between little-size">
        <div>Taux Débiteur Fixe :</div>
        <div class="whitespace-nowrap">{{ popin.fixedDebitRate | percent: "1.3-3" }}</div>
      </div>
      <div class="flex-col-between big-size">
        <div>Taux Annuel Effectif Global (TAEG) Fixe :</div>
        <div class="whitespace-nowrap">{{ popin.fixedGlobalEffectiveRate | percent: "1.3-3" }}</div>
      </div>
      <div [innerHTML]="popin.legalMentions" class="content-html little-size"></div>
      <div class="btn">
        <app-button
          (buttonClicked)="closePopin()"
          [icon]="{ name: 'CHEVRON_RIGHT', position: 'RIGHT', size: '18px' }"
          [routerLink]="popin.ctaRedirectUrl"
          label="Découvrez notre offre de financement"
          size="SMALL" />
      </div>
    </div>
  }
</dialog>
